module.exports = __webpack_public_path__ + "img/12.f0460ad3.svg";